import React, { Suspense } from 'react';
import { Route as RouteBase } from 'react-router-dom';
import { ContextLayout } from '../context/layout.context';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import AppLoader from '../components/@servierbar/lazyload/app-loader/app-loader.component';
import PropTypes from 'prop-types';
import FetchData from '../views/renderless/fetch-data/fetch-data.component';
import { createRedirect } from '../utility/util/util.service';
import { SentryRoute } from '../../src/index';

const Route = ({
  component: Component,
  fullLayout,
  authRequired,
  permissionsRequired,
  fetchStore,
  redirectToSignUpStore,
  fetchUserOrders,
  boxed,
  flexBox,

  ...routeProps
}) => {
  return (
    <SentryRoute {...routeProps}>
      <ContextLayout.Consumer>
        {(context) => {
          const Layout = context.layouts[fullLayout ? 'full' : 'vertical'];
          // attach auth check to FetchData component
          const FetchDataAndCheckAuth = authRequired
            ? withAuthenticationRequired(FetchData, {
                onRedirecting: AppLoader,
                returnTo: createRedirect, // THIS IS NEEDED OTHERWISE 404
              })
            : FetchData;

          return (
            <FetchDataAndCheckAuth
              fetchStore={fetchStore}
              fetchUserOrders={fetchUserOrders}
              redirectToSignUpStore={redirectToSignUpStore}
            >
              <Layout boxed={boxed} flexBox={flexBox}>
                <Suspense fallback={<AppLoader />}>
                  <Component />
                </Suspense>
              </Layout>
            </FetchDataAndCheckAuth>
          );
        }}
      </ContextLayout.Consumer>
    </SentryRoute>
  );
};

Route.propTypes = {
  component: PropTypes.any,
  fullLayout: PropTypes.bool,
  authRequired: PropTypes.bool,
  permissionsRequired: PropTypes.array,
  fetchStore: PropTypes.bool,
  fetchUserOrders: PropTypes.bool,
};

export default Route;
